import Image from "next/image";
import { Trans } from "translations";
import { Typography } from "ui-kit/Typography";

export const SocialProof = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
      }}
    >
      <Image
        src="/images/preventive-avatars.svg"
        alt=""
        width={58}
        height={24}
      />
      <Typography variant="body3">
        <Trans
          i18nKey="signup.preventive_step.avatar_byline"
          components={[<strong key="0" />]}
        />
      </Typography>
    </div>
  );
};
